import React, { useEffect, useState, useRef, createElement } from 'react';
import { BookOpen, CheckCircle2, Download, ShieldCheck, Lock, FileText, User, Mail, Phone, Globe, X, ArrowRight, Sparkles, Star, Clock, TrendingUp, Home, DollarSign, Zap, Target, Briefcase, XCircle, AlertTriangle, HelpCircle, MapPin, Quote, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { DownloadNotification } from '../components/DownloadNotification';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function NineToFivePage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', '9to5-LandingView');
    window.fbq('init', '4285913388317138');
    window.fbq('trackSingle', '4285913388317138', 'PageView');
    window.fbq('trackSingle', '4285913388317138', 'ViewContent', {
      content_name: '9-to-5 Landing Page',
      source: '/9-to-5'
    });
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (finalPhone && finalPhone.length < 7) {
      alert('Por favor ingresa un teléfono válido o déjalo en blanco');
      return;
    }
    if (finalPhone && !smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: '9-to-5 Guide'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: finalPhone ? `${areaCode}${finalPhone}` : '',
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: finalPhone ? `${areaCode}${finalPhone}` : '',
          areaCode: areaCode,
          source: '/9-to-5',
          page_path: '/9-to-5',
          tag: '9-to-5-guide',
          sms_consent: smsConsent,
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/escapa-del-dealership-gracias');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/escapa-del-dealership-gracias');
    } finally {
      setIsSubmitting(false);
    }
  };
  const painPoints = ['Llevas años en el mismo trabajo y tu cuenta bancaria se ve igual que hace 5 años', 'Vives para el viernes — odias los domingos en la tarde', 'Tu jefe te trata como reemplazable, porque LO ERES en su sistema', 'Mes tras mes llegas justo al fin de mes. Cero ahorro real.', 'Si te enfermas 30 días seguidos, tu economía colapsaría', 'Pides permiso para ir al doctor, llevar a tu hijo al pediatra', 'Tus hijos están creciendo sin que tú estés presente', 'Te sientes mentalmente cansado TODO el tiempo'];
  const caseStudies = [{
    name: 'Andrés',
    age: 38,
    role: 'Vendedor Toyota',
    city: 'Phoenix',
    before: '$5,500/mes · 70 horas semanales · hijos crecían sin él',
    after: '$18–22K/mes desde casa · va a TODOS los partidos',
    quote: 'Lo único que me detenía era no saber CÓMO.'
  }, {
    name: 'María',
    age: 52,
    role: 'Cajera Walmart',
    city: 'Houston',
    before: '$2,400/mes · divorciada · pensaba que era tarde',
    after: '$13–16K/mes · pagó universidad de cash a su hijo',
    quote: 'Pensé que para mí ya no había salida.'
  }, {
    name: 'Roberto',
    age: 52,
    role: 'Oficinista Seguros',
    city: 'Orlando',
    before: '$80K/año pero quemado · 18 años en aseguradora',
    after: '$22–28K/mes · vacaciones cuando quiere',
    quote: 'A los 52 era tarde. Estaba equivocado.'
  }, {
    name: 'Daniel',
    age: 22,
    role: 'Mesero',
    city: 'Miami',
    before: '$500–800/sem en propinas · vivía con su mamá',
    after: '$11–15K/mes · le compró carro a su mamá',
    quote: 'Mi mamá ya no limpia casas.'
  }, {
    name: 'Carolina',
    age: 34,
    role: 'Ama De Casa',
    city: 'Houston',
    before: '$0 propio · dependía 100% del esposo',
    after: '$13–16K/mes · gana MÁS que su esposo',
    quote: 'Mis hijos van a escuelas privadas ahora.'
  }];
  const chapters = [{
    n: '01',
    title: 'La Trampa Del 9-5',
    desc: 'Las 4 cuerdas invisibles del jefe'
  }, {
    n: '02',
    title: 'Trabajo Lineal Vs Exponencial',
    desc: ''
  }, {
    n: '03',
    title: 'El Modelo Completo Que Cambió Mi Vida',
    desc: ''
  }, {
    n: '04',
    title: '5 Historias Reales Con Números Mes A Mes',
    desc: ''
  }, {
    n: '05',
    title: 'Por Qué AHORA Es El Mejor Momento',
    desc: ''
  }, {
    n: '06',
    title: 'Las 4 Fuentes Gratuitas Para 50 Clientes',
    desc: ''
  }, {
    n: '07',
    title: 'Los 5 Mensajes WhatsApp Word-By-Word',
    desc: ''
  }, {
    n: '08',
    title: 'Tabla Completa De Precios Por Nicho',
    desc: ''
  }, {
    n: '09',
    title: 'Tu Plan De 60 Días Día Por Día',
    desc: ''
  }, {
    n: '10',
    title: 'Tu Siguiente Paso',
    desc: ''
  }];
  const faqs = [{
    q: '¿Es realmente GRATIS?',
    a: 'Sí. 100% gratis. Solo te pido tu email. NO te voy a pedir tarjeta de crédito. NO hay "pequeña letra".'
  }, {
    q: '¿Cómo recibo la guía?',
    a: 'Directamente a tu correo en menos de 60 segundos. Si no llega, revisa spam.'
  }, {
    q: '¿Tengo que saber tecnología?',
    a: 'NO. La IA hace el trabajo técnico. Tú solo necesitas saber QUÉ pedirle. La guía te lo explica todo en español.'
  }, {
    q: '¿Funciona si no soy ciudadano americano?',
    a: 'Sí. Aplica para cualquier latino que opera legalmente en USA.'
  }, {
    q: '¿Funciona si trabajo 40–60 horas a la semana?',
    a: 'Sí. María lo hizo trabajando full-time en Walmart. Andrés mientras vendía carros 70 horas. Bastan 2 horas al día.'
  }, {
    q: '¿Tengo que renunciar a mi trabajo actual?',
    a: 'NO. Te RECOMIENDO mantenerlo. Renuncias cuando tu ingreso paralelo supere tu salario. Cero riesgo.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Mis alumnos cierran su primer cliente entre día 14 y día 30. En 60 días suelen tener entre $3,000 y $8,000 facturados.'
  }, {
    q: '¿Por qué la das gratis?',
    a: 'Esta guía es la primera puerta. Mi modelo de negocio es enseñar el sistema completo. Si te gusta, vas a querer ver más. Si no, no me debes nada.'
  }];
  const featuredTestimonials = [{
    quote: 'Lo único que me detenía era no saber CÓMO. Esta guía me dio el CÓMO.',
    name: 'Andrés',
    detail: '38 · Phoenix'
  }, {
    quote: '52 años, divorciada, cajera de Walmart. Esta guía me cambió la vida.',
    name: 'María',
    detail: '52 · Houston'
  }, {
    quote: 'Pensé que a los 52 era tarde. Mi edad fue mi VENTAJA. Mes 3: $19,500.',
    name: 'Roberto',
    detail: '52 · Orlando'
  }];
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-3497">
      <noscript data-id="element-3498">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3499" />
      </noscript>

      {/* Ambient background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-3500" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3501" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3502" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-3503" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-3504">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-3505">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-3506">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-3507">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-3508">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-3509">
                  <BookOpen className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-3510" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-3511">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-3512">
                    Guía Gratuita
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-3513">
                    Cómo Escapar Del 9-5
                  </span>
                </div>
              </div>

              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-3514">
                <Briefcase className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-3515" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-3516">
                  Empleados Latinos
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-3517" />
                <Globe className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-3518" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-3519">
                  En USA
                </span>
              </div>

              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-3520">
                <Download className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-3521" />
                <span className="hidden sm:inline" data-id="element-3522">Descargar Gratis</span>
                <span className="sm:hidden" data-id="element-3523">Descargar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-3524" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-4 sm:px-5 lg:px-8 pt-20 md:pt-28 pb-12" data-id="element-3525">
        {/* ============ SECTION 1 — HERO ============ */}
        <section className="mb-16 md:mb-24 text-center" data-id="element-3526">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-3.5 py-1.5 mb-5 md:mb-6" data-id="element-3527">
            <AlertTriangle className="w-3.5 h-3.5 text-red-400" data-id="element-3528" />
            <span className="text-red-400 text-[10px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-3529">
              Para Empleados Latinos Cansados Del 9-5
            </span>
          </div>

          <h1 className="text-[2rem] sm:text-[2.5rem] md:text-5xl lg:text-[4rem] xl:text-[4.5rem] font-black leading-[1.03] tracking-tight mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-3530">
            Cómo Escapar Del 9-5
            <br data-id="element-3531" />
            <span className="relative inline-block" data-id="element-3532">
              <span className="relative z-10 text-amber-400" data-id="element-3533">
                En Los Próximos 60 Días
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2.5 md:h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-3534" />
            </span>
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-3535">
            Descarga GRATIS la guía de{' '}
            <span className="text-white font-semibold" data-id="element-3536">30 páginas</span> que
            está leyendo cualquier empleado latino en USA que quiera generar{' '}
            <span className="text-white font-semibold" data-id="element-3537">
              $5,000–$15,000 EXTRAS al mes
            </span>{' '}
            desde casa — sin renunciar primero, sin invertir capital, sin saber
            tecnología.
          </p>

          {/* Book image */}
          <div className="relative flex flex-col items-center mb-10 md:mb-14" data-id="element-3538">
            <div className="relative w-full max-w-2xl lg:max-w-3xl" data-id="element-3539">
              <div className="hidden md:flex absolute top-4 left-0 lg:-left-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-3540">
                <div className="flex items-center gap-2.5" data-id="element-3541">
                  <div className="w-9 h-9 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center" data-id="element-3542">
                    <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-3543" />
                  </div>
                  <div className="text-left" data-id="element-3544">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3545">
                      Ingreso meta
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-3546">
                      $5K–$15K/mes
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:flex absolute bottom-4 right-0 lg:-right-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-3547">
                <div className="flex items-center gap-2.5" data-id="element-3548">
                  <div className="w-9 h-9 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-3549">
                    <FileText className="w-4 h-4 text-amber-400" data-id="element-3550" />
                  </div>
                  <div className="text-left" data-id="element-3551">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3552">
                      Contenido
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-3553">
                      30 páginas
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 bg-amber-400/20 blur-[120px] rounded-full scale-90 pointer-events-none" data-id="element-3554" />

              <img src="https://cdn.magicpatterns.com/uploads/3koR9Um6Z3JLvhRxNTnoti/WEBINAR_BONUS_GUIDE_BOOK.png" alt="Cómo Escapar Del 9-5 — Guía Gratis para empleados latinos en USA" className="relative w-full h-auto drop-shadow-[0_30px_60px_rgba(245,158,11,0.35)] hover:scale-[1.02] transition-transform duration-500" data-id="element-3555" />
            </div>

            {/* Mobile badges */}
            <div className="flex md:hidden items-stretch justify-center gap-2.5 mt-5 w-full px-2" data-id="element-3556">
              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-3557">
                <div className="w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3558">
                  <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-3559" />
                </div>
                <div className="text-left min-w-0" data-id="element-3560">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3561">
                    Ingreso meta
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-3562">
                    $5K–$15K/mes
                  </div>
                </div>
              </div>

              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-3563">
                <div className="w-8 h-8 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3564">
                  <FileText className="w-4 h-4 text-amber-400" data-id="element-3565" />
                </div>
                <div className="text-left min-w-0" data-id="element-3566">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3567">
                    Contenido
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-3568">
                    30 páginas
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile CTA */}
            <div className="md:hidden mt-5 px-2 w-full" data-id="element-3569">
              <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base uppercase tracking-tight rounded-2xl py-5 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 overflow-hidden" data-id="element-3570">
                <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-3571">
                  <Download className="w-5 h-5" data-id="element-3572" />
                  Descargar La Guía Gratis
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-3573" />
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3574" />
              </button>
            </div>
          </div>

          {/* Desktop CTA + Trust */}
          <div className="max-w-md mx-auto" data-id="element-3575">
            <button type="button" onClick={() => setShowModal(true)} className="hidden md:block group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-3576">
              <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-3577">
                <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-3578" />
                Descargar La Guía Gratis
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-3579" />
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3580" />
            </button>

            <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-3581">
              {['100% Gratis', 'Sin spam', 'Descarga inmediata', 'En español'].map(item => <div key={item} className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.06] rounded-full px-3 py-1.5" data-id="element-3582">
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" data-id="element-3583" />
                  <span className="text-[11px] md:text-xs text-gray-400 font-medium truncate" data-id="element-3584">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 2 — PAIN AGITATION ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3585">
          <div className="max-w-4xl mx-auto" data-id="element-3586">
            <div className="text-center mb-10 md:mb-12" data-id="element-3587">
              <div className="inline-block text-red-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3588">
                Sé Por Qué Estás Aquí
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3589">
                Esta Guía Es <span className="text-amber-400" data-id="element-3590">Para Ti Si</span>{' '}
                Reconoces Esto:
              </h2>
            </div>

            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-3591">
              {painPoints.map(p => <li key={p} className="flex items-start gap-3 bg-red-950/20 border border-red-500/15 rounded-xl px-4 py-3.5 md:px-5 md:py-4" data-id="element-3592">
                  <div className="w-8 h-8 md:w-9 md:h-9 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3593">
                    <X className="w-4 h-4 text-red-400" data-id="element-3594" />
                  </div>
                  <span className="text-sm md:text-base text-gray-200 font-medium leading-snug" data-id="element-3595">
                    {p}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 md:mt-10 max-w-2xl mx-auto bg-amber-500/10 border border-amber-500/30 rounded-2xl px-5 py-4 md:px-7 md:py-5 flex items-start gap-3 md:gap-4" data-id="element-3596">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0" data-id="element-3597">
                <Target className="w-4 h-4 md:w-5 md:h-5 text-amber-400" data-id="element-3598" />
              </div>
              <p className="text-sm md:text-base lg:text-lg text-amber-100 leading-snug" data-id="element-3599">
                Si reconociste{' '}
                <span className="font-black text-amber-400" data-id="element-3600">4 o más</span> —
                esta guía fue escrita EXACTAMENTE para ti.
              </p>
            </div>
          </div>
        </section>

        {/* ============ SECTION 3 — SOLUTION ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3601">
          <div className="max-w-4xl mx-auto" data-id="element-3602">
            <div className="text-center mb-10 md:mb-12" data-id="element-3603">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3604">
                La Solución
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3605">
                Hay Un Modelo Que <span className="text-amber-400" data-id="element-3606">NADIE</span>{' '}
                Te Está Enseñando.
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/30 rounded-3xl p-6 md:p-10 lg:p-12 shadow-[0_0_40px_rgba(245,158,11,0.1)]" data-id="element-3607">
              <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed mb-6 md:mb-8" data-id="element-3608">
                Mientras tú llegas al mismo trabajo todos los días — hay
                empleados latinos como TÚ haciendo algo completamente diferente
                en sus{' '}
                <span className="text-white font-semibold" data-id="element-3609">
                  2–3 horas libres
                </span>
                :
              </p>

              <p className="text-xl md:text-2xl lg:text-3xl font-black text-amber-400 leading-tight mb-6 md:mb-8" data-id="element-3610">
                Construyen páginas web para negocios locales en USA.
              </p>

              <ul className="space-y-3 md:space-y-3.5 mb-6 md:mb-8" data-id="element-3611">
                {[{
                icon: Clock,
                text: 'En 1–2 horas.'
              }, {
                icon: Sparkles,
                text: 'Con inteligencia artificial.'
              }, {
                icon: DollarSign,
                text: 'Las cobran entre $500 y $1,500 cada una.'
              }, {
                icon: Zap,
                text: 'No necesitan saber programar.'
              }, {
                icon: ShieldCheck,
                text: 'No necesitan capital inicial.'
              }, {
                icon: Briefcase,
                text: 'No necesitan dejar su trabajo primero.'
              }].map(item => <li key={item.text} className="flex items-center gap-3 md:gap-4 bg-white/[0.03] border border-white/[0.08] rounded-xl px-4 py-3 md:px-5 md:py-3.5" data-id="element-3612">
                    <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3613">
                      <item.icon className="w-4 h-4 text-amber-400" data-id="element-3614" />
                    </div>
                    <span className="text-sm md:text-base lg:text-lg text-gray-200 leading-snug" data-id="element-3615">
                      {item.text}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-[#0a1428] border-2 border-amber-500/40 rounded-2xl px-5 py-4 md:px-7 md:py-5 text-center" data-id="element-3616">
                <p className="text-sm md:text-base lg:text-lg text-white font-bold leading-snug" data-id="element-3617">
                  Lo único que necesitan:{' '}
                  <span className="text-amber-400" data-id="element-3618">
                    dedicar 2–3 horas al día durante 60 días.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 4 — CASE STUDIES ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3619">
          <div className="text-center mb-10 md:mb-14" data-id="element-3620">
            <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3621">
              Casos Reales
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3622">
              5 Empleados Latinos Que{' '}
              <span className="text-amber-400" data-id="element-3623">Ya Lo Lograron</span>:
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6 max-w-6xl mx-auto" data-id="element-3624">
            {caseStudies.map((c, idx) => <div key={c.name} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-5 md:p-6 lg:p-7 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300 flex flex-col" data-id="element-3625">
                {/* Case # */}
                <div className="absolute top-5 right-5 text-amber-400/15 group-hover:text-amber-400/30 transition-colors text-3xl md:text-4xl font-black leading-none" data-id="element-3626">
                  0{idx + 1}
                </div>

                {/* Header */}
                <div className="flex items-start gap-3 mb-4 md:mb-5" data-id="element-3627">
                  <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3628">
                    <User className="w-5 h-5 text-amber-400" data-id="element-3629" />
                  </div>
                  <div className="min-w-0 pr-10" data-id="element-3630">
                    <h3 className="text-base md:text-lg lg:text-xl font-black text-white leading-tight" data-id="element-3631">
                      {c.name}, <span className="text-amber-400" data-id="element-3632">{c.age}</span>
                    </h3>
                    <div className="flex items-center gap-1.5 mt-1 text-[11px] md:text-xs text-gray-400" data-id="element-3633">
                      <Briefcase className="w-3 h-3" data-id="element-3634" />
                      <span className="truncate" data-id="element-3635">{c.role}</span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5 text-[11px] md:text-xs text-gray-400" data-id="element-3636">
                      <MapPin className="w-3 h-3" data-id="element-3637" />
                      <span className="truncate" data-id="element-3638">{c.city}</span>
                    </div>
                  </div>
                </div>

                {/* Before */}
                <div className="bg-red-950/20 border border-red-500/15 rounded-xl px-3.5 py-3 mb-2.5" data-id="element-3639">
                  <div className="text-[10px] md:text-xs font-black uppercase tracking-[0.16em] text-red-400 mb-1.5 flex items-center gap-1.5" data-id="element-3640">
                    <XCircle className="w-3 h-3" data-id="element-3641" />
                    Antes
                  </div>
                  <p className="text-xs md:text-sm text-gray-300 leading-snug" data-id="element-3642">
                    {c.before}
                  </p>
                </div>

                {/* After */}
                <div className="bg-amber-950/25 border border-amber-500/30 rounded-xl px-3.5 py-3 mb-4" data-id="element-3643">
                  <div className="text-[10px] md:text-xs font-black uppercase tracking-[0.16em] text-amber-400 mb-1.5 flex items-center gap-1.5" data-id="element-3644">
                    <CheckCircle2 className="w-3 h-3" data-id="element-3645" />
                    Hoy
                  </div>
                  <p className="text-xs md:text-sm text-white font-semibold leading-snug" data-id="element-3646">
                    {c.after}
                  </p>
                </div>

                {/* Quote */}
                <div className="relative bg-[#0a1428] border border-amber-500/20 rounded-xl px-3.5 py-3 mt-auto" data-id="element-3647">
                  <Quote className="absolute -top-2 left-3 w-4 h-4 text-amber-400/40 bg-[#0a1428] px-0.5" data-id="element-3648" />
                  <p className="text-xs md:text-sm text-gray-300 italic leading-snug" data-id="element-3649">
                    "{c.quote}"
                  </p>
                </div>
              </div>)}
          </div>

          <p className="mt-10 md:mt-12 text-center text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-3650">
            Todos partieron desde CERO. Ninguno tenía capital, conocimientos
            técnicos, o tiempo extra.{' '}
            <span className="text-amber-400 font-black" data-id="element-3651">
              Si ellos pudieron — tú también.
            </span>
          </p>
        </section>

        {/* ============ SECTION 5 — WHAT'S INSIDE ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3652">
          <div className="max-w-5xl mx-auto" data-id="element-3653">
            <div className="text-center mb-10 md:mb-14" data-id="element-3654">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3655">
                Qué Hay Dentro
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3656">
                Las 30 Páginas Que Vas A{' '}
                <span className="text-amber-400" data-id="element-3657">Descargar Contienen</span>:
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-3658">
              {chapters.map(ch => <div key={ch.n} className="group flex items-start gap-4 bg-white/[0.025] border border-white/[0.08] hover:border-amber-500/40 hover:bg-white/[0.04] rounded-xl px-4 py-3.5 md:px-5 md:py-4 transition-all duration-300" data-id="element-3659">
                  <div className="text-amber-400 font-black text-xl md:text-2xl leading-none flex-shrink-0 w-9 md:w-10" data-id="element-3660">
                    {ch.n}
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-3661">
                    <h3 className="text-sm md:text-base font-black text-white leading-tight" data-id="element-3662">
                      {ch.title}
                    </h3>
                    {ch.desc && <p className="text-xs md:text-sm text-gray-400 mt-1 leading-snug" data-id="element-3663">
                        {ch.desc}
                      </p>}
                  </div>
                </div>)}
            </div>

            <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-400" data-id="element-3664">
              <span className="flex items-center gap-1.5" data-id="element-3665">
                <FileText className="w-3.5 h-3.5 text-amber-400" data-id="element-3666" /> 30 páginas
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3667">
                <Globe className="w-3.5 h-3.5 text-amber-400" data-id="element-3668" /> 100% en español
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3669">
                <Download className="w-3.5 h-3.5 text-amber-400" data-id="element-3670" /> Descarga
                inmediata
              </span>
            </div>
          </div>
        </section>

        {/* ============ SECTION 6 — ABOUT GABRIEL ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3671">
          <div className="max-w-5xl mx-auto" data-id="element-3672">
            <div className="text-center mb-10 md:mb-12" data-id="element-3673">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3674">
                Quién Soy
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3675">
                ¿Quién Soy Y{' '}
                <span className="text-amber-400" data-id="element-3676">
                  Por Qué Deberías Escucharme
                </span>
                ?
              </h2>
            </div>

            <div className="bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border border-amber-500/20 rounded-3xl p-6 md:p-10 lg:p-12" data-id="element-3677">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-10 items-center" data-id="element-3678">
                {/* Avatar */}
                <div className="lg:col-span-2 flex justify-center" data-id="element-3679">
                  <div className="relative" data-id="element-3680">
                    <div className="absolute inset-0 bg-amber-400/30 blur-2xl rounded-full" data-id="element-3681" />
                    <div className="relative w-40 h-40 md:w-52 md:h-52 lg:w-56 lg:h-56 rounded-3xl bg-gradient-to-br from-amber-400 to-amber-600 border-4 border-amber-500/40 shadow-[0_20px_50px_-15px_rgba(245,158,11,0.5)] overflow-hidden flex items-center justify-center" data-id="element-3682">
                      <User className="w-20 h-20 md:w-28 md:h-28 text-[#0a1428]/60" data-id="element-3683" />
                    </div>
                    <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#0a1428] border border-amber-500/40 rounded-full px-3 py-1 flex items-center gap-1.5 shadow-xl whitespace-nowrap" data-id="element-3684">
                      <Award className="w-3 h-3 text-amber-400" data-id="element-3685" />
                      <span className="text-[10px] md:text-xs font-black uppercase tracking-tight text-amber-400" data-id="element-3686">
                        Gabriel Beltrán
                      </span>
                    </div>
                  </div>
                </div>

                {/* Text */}
                <div className="lg:col-span-3 space-y-3 md:space-y-4 text-sm md:text-base lg:text-[17px] text-gray-300 leading-relaxed" data-id="element-3687">
                  <p data-id="element-3688">
                    Soy{' '}
                    <span className="text-white font-bold" data-id="element-3689">
                      Gabriel Beltrán
                    </span>
                    . Creador de{' '}
                    <span className="text-amber-400 font-black" data-id="element-3690">
                      AI Web Closer System
                    </span>
                    .
                  </p>
                  <p className="text-white font-semibold" data-id="element-3691">
                    Pero antes que nada — yo también fui empleado 9-5.
                  </p>
                  <p data-id="element-3692">
                    Pasé años en trabajos donde mi tiempo NO era mío. Donde mi
                    sueldo subía 3% al año mientras la vida subía 10%. Donde mi
                    jefe ganaba 5 veces más por sentarse en su oficina.
                  </p>
                  <p data-id="element-3693">
                    En los últimos años he ayudado a{' '}
                    <span className="text-white font-bold" data-id="element-3694">
                      cientos de empleados latinos en USA
                    </span>{' '}
                    a salir del 9-5 y construir negocios propios desde cero.
                  </p>
                  <p data-id="element-3695">
                    Mis alumnos están en{' '}
                    <span className="text-white" data-id="element-3696">
                      Phoenix, Houston, Miami, Orlando, Dallas, Los Angeles,
                      Chicago
                    </span>
                    .
                  </p>
                  <p className="text-amber-400 font-bold pt-1" data-id="element-3697">
                    Esta guía es mi forma de devolverte 10 años de aprendizaje
                    en 30 páginas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 7 — FAQ ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3698">
          <div className="max-w-3xl mx-auto" data-id="element-3699">
            <div className="text-center mb-10 md:mb-12" data-id="element-3700">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3701">
                FAQ
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-3702">
                Preguntas <span className="text-amber-400" data-id="element-3703">Frecuentes</span>:
              </h2>
            </div>

            <div className="space-y-3 lg:space-y-4" data-id="element-3704">
              {faqs.map((f, idx) => <div key={f.q} className={`bg-white/[0.025] border rounded-2xl overflow-hidden transition-colors ${openFaq === idx ? 'border-amber-500/40' : 'border-white/[0.08]'}`} data-id="element-3705">
                  <button type="button" onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full flex items-center gap-3 lg:gap-4 px-5 py-4 lg:px-7 lg:py-5 text-left hover:bg-white/[0.015] transition-colors" data-id="element-3706">
                    <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${openFaq === idx ? 'bg-amber-500/15 border border-amber-500/40' : 'bg-white/[0.04] border border-white/[0.08]'}`} data-id="element-3707">
                      <HelpCircle className={`w-4 h-4 lg:w-[18px] lg:h-[18px] ${openFaq === idx ? 'text-amber-400' : 'text-gray-400'}`} data-id="element-3708" />
                    </div>
                    <span className="flex-1 text-white font-bold text-sm md:text-base lg:text-lg leading-snug" data-id="element-3709">
                      {f.q}
                    </span>
                    <ArrowRight className={`w-4 h-4 lg:w-5 lg:h-5 text-gray-500 transition-transform flex-shrink-0 ${openFaq === idx ? 'rotate-90 text-amber-400' : ''}`} data-id="element-3710" />
                  </button>
                  {openFaq === idx && <div className="px-5 pb-5 lg:px-7 lg:pb-6 pl-[68px] lg:pl-[92px] text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3711">
                      {f.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 8 — FINAL CTA ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3712">
          <div className="relative max-w-3xl mx-auto" data-id="element-3713">
            <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-3714" />

            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-6 md:p-10 lg:p-12 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-3715">
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-3716" />

              <div className="relative" data-id="element-3717">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-3718">
                  <Clock className="w-3.5 h-3.5 text-amber-400" data-id="element-3719" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-3720">
                    Última Llamada
                  </span>
                </div>

                <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-5 max-w-xl mx-auto" data-id="element-3721">
                  ¿Listo Para{' '}
                  <span className="text-amber-400" data-id="element-3722">Descargar La Guía</span>?
                </h2>

                <div className="space-y-3 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-300 mb-7 md:mb-8 max-w-lg mx-auto leading-relaxed text-left" data-id="element-3723">
                  <p data-id="element-3724">Cada día que pasa es un día más en el mismo trabajo.</p>
                  <p data-id="element-3725">Un día más viviendo para el viernes.</p>
                  <p data-id="element-3726">Una semana más esperando vacaciones que nunca llegan.</p>
                  <p className="text-white font-semibold" data-id="element-3727">
                    Descargar esta guía NO te cuesta nada.
                  </p>
                  <p className="text-amber-400 font-bold" data-id="element-3728">
                    Pero NO descargarla puede costarte otros 5 años en el 9-5.
                  </p>
                </div>

                <button type="button" onClick={() => setShowModal(true)} className="group relative w-full max-w-md mx-auto bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex" data-id="element-3729">
                  <span className="relative z-10 flex items-center justify-center gap-2.5 w-full" data-id="element-3730">
                    <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-3731" />
                    Descargar La Guía Gratis
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-3732" />
                  </span>
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3733" />
                </button>

                <div className="mt-5 flex items-center justify-center gap-x-5 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-3734">
                  <span className="flex items-center gap-1.5" data-id="element-3735">
                    <FileText className="w-3.5 h-3.5 text-emerald-400" data-id="element-3736" /> 30
                    páginas
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-3737">
                    <Download className="w-3.5 h-3.5 text-emerald-400" data-id="element-3738" />{' '}
                    Descarga inmediata
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-3739">
                    <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" data-id="element-3740" /> Sin
                    spam
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 9 — FEATURED TESTIMONIALS ============ */}
        <section className="mb-8" data-id="element-3741">
          <div className="max-w-6xl mx-auto" data-id="element-3742">
            <div className="text-center mb-10 md:mb-12" data-id="element-3743">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3744">
                Testimonios
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3745">
                Lo Que Dicen{' '}
                <span className="text-amber-400" data-id="element-3746">Personas Que Aplicaron</span>{' '}
                Este Sistema:
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6" data-id="element-3747">
              {featuredTestimonials.map(t => <div key={t.name} className="relative bg-white/[0.025] border border-white/[0.08] hover:border-amber-500/30 rounded-2xl p-5 md:p-6 lg:p-7 transition-all duration-300 flex flex-col" data-id="element-3748">
                  <div className="flex items-center gap-0.5 mb-4" data-id="element-3749">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400 fill-amber-400" data-id="element-3750" />)}
                  </div>
                  <Quote className="w-6 h-6 text-amber-400/30 mb-3" data-id="element-3751" />
                  <p className="text-sm md:text-base lg:text-lg text-white font-medium italic leading-snug mb-5 flex-1" data-id="element-3752">
                    "{t.quote}"
                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-white/[0.06]" data-id="element-3753">
                    <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3754">
                      <User className="w-4 h-4 text-amber-400" data-id="element-3755" />
                    </div>
                    <div data-id="element-3756">
                      <div className="text-white font-black text-sm md:text-base leading-tight" data-id="element-3757">
                        {t.name}
                      </div>
                      <div className="text-gray-400 text-[11px] md:text-xs uppercase tracking-wider font-bold mt-0.5" data-id="element-3758">
                        {t.detail}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-3759" />

      {/* Social proof download notification */}
      <DownloadNotification data-id="element-3760" />

      {/* Lead Capture Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in" onClick={() => setShowModal(false)} data-id="element-3761">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)] max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-3762">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-3763">
              <X className="w-6 h-6" data-id="element-3764" />
            </button>

            <div className="text-center mb-6" data-id="element-3765">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-3766">
                <Download className="w-6 h-6 text-amber-400" data-id="element-3767" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-3768">
                Descarga Tu Guía
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-3769">
                Ingresa tus datos para recibir acceso inmediato
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3770">
              <div className="space-y-1" data-id="element-3771">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3772">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-3773">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3774">
                    <User className="h-5 w-5 text-gray-500" data-id="element-3775" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-3776" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-3777">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3778">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-3779">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3780">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-3781" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-3782" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-3783">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-3784">
                  WhatsApp (Opcional)
                </label>
                <div className="flex gap-2" data-id="element-3785">
                  <div className="relative w-1/3" data-id="element-3786">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-3787">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-3788" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-3789">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-3790">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-3791">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-3792">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-3793" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número (opcional)" autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-3794" />
                  </div>
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer group pt-1" data-id="element-3795">
                <div className="relative flex-shrink-0 mt-0.5" data-id="element-3796">
                  <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-3797" />
                  <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-3798">
                    {smsConsent && <CheckCircle2 className="w-3.5 h-3.5 text-[#0a1428]" strokeWidth={3} data-id="element-3799" />}
                  </div>
                </div>
                <span className="text-[11px] md:text-xs text-gray-400 leading-relaxed" data-id="element-3800">
                  Acepto recibir mensajes SMS con recordatorios e información de
                  esta guía. Puedo cancelar en cualquier momento respondiendo
                  STOP.
                </span>
              </label>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-3801">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-3802">
                  {isSubmitting ? <>Enviando...</> : <>
                      <Download className="w-5 h-5" data-id="element-3803" />
                      Descargar Ahora
                      <ArrowRight className="w-5 h-5" data-id="element-3804" />
                    </>}
                </span>
              </button>

              <div className="flex items-center justify-center gap-1.5 text-xs text-gray-500" data-id="element-3805">
                <Lock className="w-3 h-3" data-id="element-3806" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}